{
	"backLinkTitle": "Zpět na Správa prohlášení",
	"invoicedQuantity": "Fakturované množství",
	"remainingForDeclarationCreation": "Zbývá k vytvoření prohlášení",
	"nonTransferableAmount": "Nepřidělitelná částka",
	"btnCreateDeclaration": "+ Vytvořit prohlášení",
	"errorMessage": "Podrobnosti o materiálu se nepodařilo načíst"
}
